import { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import { addLandrEventListener, LandrEventType } from '@landr/core';
import { ProfileQueryDefinition } from '../../ProfileProvider/queries.es.js';
import { ProfilePrivacyFragment } from '../fragments.es.js';

var updateUserWorkAvailabilityCache = function updateUserWorkAvailabilityCache(cache, eventData, landrUserId) {
  cache.writeFragment({
    id: "UserProfile:".concat(landrUserId),
    fragment: ProfilePrivacyFragment,
    data: {
      id: landrUserId,
      isPrivateProfile: eventData.isPrivateProfile
    }
  });
};
var useListenForUserProfilePrivacyUpdate = function useListenForUserProfilePrivacyUpdate() {
  var apolloClient = useApolloClient();
  var data = apolloClient === null || apolloClient === void 0 ? void 0 : apolloClient.readQuery({
    query: ProfileQueryDefinition
  });
  var landrUserId = data === null || data === void 0 ? void 0 : data.currentProfile.id;
  useEffect(function () {
    var callback = function callback(data) {
      updateUserWorkAvailabilityCache(apolloClient.cache, data, landrUserId);
    };
    var unsubscribe = addLandrEventListener(LandrEventType.UserProfilePrivacyUpdate, callback);
    return unsubscribe;
  }, [apolloClient, landrUserId]);
};

export { useListenForUserProfilePrivacyUpdate };
